<div class="tpd">
  <div class="tpd__header">
    <span class="tpd__title" [title]="data.docName">{{ data.docName }}</span>
    <button mat-icon-button type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="tpd__body">
    @if (loading) {
      <mat-spinner [diameter]="60" strokeWidth="6"></mat-spinner>
    }
    @if (error) {
      <div class="tpd__error">
        <mat-icon>broken_image</mat-icon>
        <span>Грешка при зареждане</span>
      </div>
    }
    @if (imageUrl && !loading && !error) {
      <div class="tpd__image-wrap" itfgZoomImage [url]="imageUrl">
        <img class="tpd__img" [src]="imageUrl" [alt]="data.docName" />
      </div>
    }
  </div>
</div>
